import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { ItemMasterRequest } from '../../models/code-creation/code-creation';
import { SearchItemMasterRequest } from '../../models/code-creation/search';

@Injectable({
  providedIn: 'root',
})
export class ItemMasterRequestService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item-master-request';

  getById(id: string): Observable<ApiResponse<ItemMasterRequest>> {
    return this.httpClient.get<ApiResponse<ItemMasterRequest>>(`${this.baseUrl}/${id}`);
  }

  create(itemMasterRequest: ItemMasterRequest): Observable<ApiResponse<ItemMasterRequest>> {
    return this.httpClient.post<ApiResponse<ItemMasterRequest>>(`${this.baseUrl}`, itemMasterRequest);
  }

  update(itemMasterRequest: ItemMasterRequest): Observable<ApiResponse<ItemMasterRequest>> {
    return this.httpClient.put<ApiResponse<ItemMasterRequest>>(`${this.baseUrl}/${itemMasterRequest.id}`, itemMasterRequest);
  }

  search(
    searchCommand: SearchItemMasterRequest,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<ItemMasterRequest>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder ?? -1}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ItemMasterRequest>>>(url, searchCommand);
  }
}
